import type { OperationVariables, TypedDocumentNode } from '@apollo/client';
import { isNil } from 'es-toolkit';
import { print as gqlDocToQueryString } from 'graphql';

import { apiHost } from '@savvy/deprecated-shared/api/api-host';
import { LocalStorage } from '@savvy/deprecated-shared/utils/local-storage';

async function postToGraphQL<TVariables extends OperationVariables, TData>(
  method: 'query' | 'mutation',
  queryDocumentNode: TypedDocumentNode<TData, TVariables>,
  variables?: TVariables,
): Promise<TData | undefined> {
  const authToken = await LocalStorage.getItem('accessToken');

  const response = await fetch(`${apiHost}/graphql`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: !isNil(authToken) ? `Bearer ${authToken}` : '',
    },
    body: JSON.stringify({
      [method]: gqlDocToQueryString(queryDocumentNode),
      variables,
    }),
  });

  const result: { data: TData } = await response.json();
  return result.data;
}

export async function fetchQueryWithoutCaching<TVariables extends OperationVariables, TData>(
  queryDocumentNode: TypedDocumentNode<TData, TVariables>,
  variables?: TVariables,
): Promise<TData | undefined> {
  return await postToGraphQL('query', queryDocumentNode, variables);
}
